/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

// Librairies React
import { Row, Col, Container } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

// Composants
import Loading from './Loading';
import LeftPanel from './LeftPanel/LeftPanel';

// Styles
import '../styles/Config.css';

// Fonctions
import { ComputeHorsNormes } from "../components/Fonctions";
import { db } from './Firebase';
import { collection, getDocs } from "firebase/firestore";

import RightPanel from './RightPanel/RightPanel';

function Config() {
	const [store_type, setStore] = useState(0);
	const [commande, setCommande] = useState(2);
	const [orientation, setOrientation] = useState(0);
	const [compas, setCompas] = useState('nord');
	const [securite, setSecurite] = useState(0);
	const [largeur, setRangeLargeur] = useState(350);
	const [hauteur, setRangeHauteur] = useState(600);
	const [couleur, setCouleur] = useState(0);
	const [environnement, setEnvironnement] = useState(1);
	const [tarifs, setTarifs] = useState([{}]);
	const [dimensions, setDimensions] = useState([{}]);
	const [toggle1, setToggle1] = useState(false);
	const [toggle2, setToggle2] = useState(false);
	const [HorsNormes, setHorsNormes] = useState(false);

	const tarifsRef = collection(db, "tarifs");
	const dimensionsRef = collection(db, "dimensions");

	const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

	useEffect(() => {
		async function getTarifs() {
			const data = await getDocs(tarifsRef);
			setTarifs(data.docs[0].data());
			setToggle1(false);
		};
		getTarifs();
	}, [toggle1]);

	useEffect(() => {
		async function getDim() {
			const data = await getDocs(dimensionsRef);
			setDimensions([data.docs[1].data(), data.docs[0].data()]);
			setToggle2(false);
		};
		getDim();
	}, [toggle2]);

	useEffect(() => {
		setHorsNormes(ComputeHorsNormes(largeur, hauteur, store_type, commande));
	}, [largeur, hauteur, store_type, commande, HorsNormes]);

	//console.log("Rendering", Date.now());

	return (
		<Container fluid>
			{tarifs['marge_surface'] !== undefined && dimensions[0]['largeur_min'] !== undefined ?
			<Row>
				<Col>
					<LeftPanel
					tarifs={tarifs}
					HorsNormes={HorsNormes}
					isPortrait={isPortrait}
					store_type={store_type}
					commande={commande}
					compas={compas}
					securite={securite}
					largeur={largeur}
					hauteur={hauteur}
					couleur={couleur}
					environnement={environnement}
					orientation={orientation}
					/>
				</Col>
				<Col>
					<RightPanel
					isPortrait={isPortrait}
					HorsNormes={HorsNormes}
					store_type={store_type} setStore={setStore}
					commande={commande} setCommande={setCommande}
					orientation={orientation} setOrientation={setOrientation}
					compas={compas} setCompas={setCompas}
					securite={securite} setSecurite={setSecurite}
					largeur={largeur} setRangeLargeur={setRangeLargeur}
					hauteur={hauteur} setRangeHauteur={setRangeHauteur}
					couleur={couleur} setCouleur={setCouleur}
					environnement={environnement} setEnvironnement={setEnvironnement}
					dimensions={dimensions}
					/>
				</Col>
			</Row> :
			<Loading/>}
		</Container>
	);
}

export default Config;
